var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "320010",
                reset: true,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                )
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DataExport")))]
                  ),
                  _c(
                    "el-menu",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.combinedManifest,
                          expression: "combinedManifest"
                        }
                      ],
                      staticClass:
                        "el-menu-button el-button el-button--primary el-button--mini",
                      staticStyle: { width: "90px", "vertical-align": "top" },
                      attrs: {
                        "text-color": "#404144",
                        "active-text-color": "#404144",
                        mode: "horizontal"
                      },
                      on: { select: _vm.toBooking }
                    },
                    [
                      _c(
                        "el-submenu",
                        {
                          attrs: { index: "index", disabled: !_vm.bookingBtn }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "el-menu-btn-text",
                              attrs: { slot: "title" },
                              slot: "title"
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.EDIBooking")))]
                          ),
                          _c(
                            "el-submenu",
                            { attrs: { index: "original" } },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.Original")))
                              ]),
                              _c(
                                "el-menu-item",
                                {
                                  attrs: {
                                    index: "API0",
                                    disabled: !_vm.bookingEDIApiOpen
                                  }
                                },
                                [_vm._v("API")]
                              ),
                              _c("el-menu-item", { attrs: { index: "FTP1" } }, [
                                _vm._v("FTP")
                              ])
                            ],
                            2
                          ),
                          _c(
                            "el-submenu",
                            { attrs: { index: "correct" } },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.Correct")))
                              ]),
                              _c("el-menu-item", { attrs: { index: "FTP0" } }, [
                                _vm._v("FTP")
                              ]),
                              _c(
                                "el-menu-item",
                                {
                                  attrs: {
                                    index: "API1",
                                    disabled: !_vm.bookingEDIApiOpen
                                  }
                                },
                                [_vm._v("API")]
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "320010",
                  "grid-options": _vm.gridOptions,
                  "side-bar": {
                    toolPanels: ["columns", "filter"],
                    visible: false
                  },
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "grid-params": _vm.gridParams,
                  "check-main-record": false,
                  "deselect-main-record": false
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "320010",
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function($event) {
                    return _vm.toAdvancedQuery()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("dialog-selector", {
        attrs: {
          visible: _vm.selectorDialog.visible,
          title: _vm.selectorDialog.title,
          "row-data": _vm.selectorDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectorDialog, "visible", $event)
          },
          selected: _vm.selectorDialogCallback
        }
      }),
      _c("message-preview-dialog", {
        attrs: {
          visible: _vm.messagePreviewDialog.visible,
          params: _vm.messagePreviewDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.messagePreviewDialog, "visible", $event)
          }
        }
      }),
      _c("error-log-dialog", {
        attrs: {
          visible: _vm.errorLogDialog.visible,
          "error-log": _vm.errorLogDialog.errorLog
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.errorLogDialog, "visible", $event)
          }
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: {},
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("api-popup", {
        attrs: {
          visible: _vm.apiPopup.visible,
          title: _vm.apiPopup.title,
          "interface-type": _vm.apiPopup.interfaceType,
          "interface-array": _vm.apiPopup.interfaceArray
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.apiPopup, "visible", $event)
          },
          selectedApi: _vm.selectedApiCallback
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }